import { render, staticRenderFns } from "./loveThreeMatchRes.vue?vue&type=template&id=56781f36&scoped=true"
import script from "./loveThreeMatchRes.vue?vue&type=script&lang=js"
export * from "./loveThreeMatchRes.vue?vue&type=script&lang=js"
import style0 from "./loveThreeMatchRes.vue?vue&type=style&index=0&id=56781f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56781f36",
  null
  
)

export default component.exports